import { render } from "./TextButton.vue?vue&type=template&id=24e3f8e8&scoped=true"
import script from "./TextButton.vue?vue&type=script&lang=js"
export * from "./TextButton.vue?vue&type=script&lang=js"

import "./TextButton.vue?vue&type=style&index=0&id=24e3f8e8&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e3f8e8"]])

export default __exports__